import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Color} from 'ng2-charts';
import {ChartOptions} from 'chart.js';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-journey-session-dashboard',
  templateUrl: './journey-session-dashboard.component.html',
  styleUrls: ['./journey-session-dashboard.component.scss']
})
export class JourneySessionDashboardComponent implements OnInit, OnChanges {

  selectedTab = 0;

  @Input() sessionLogs;
  @Input() sessionId;

  columns = ['Date', 'Feature', 'Action', 'Result', 'Status Code', 'Page', 'Log Level'];
  entityMappingToSort = ['Date', '', '', '', '', '', ''];

  chartLabels: string[] = ['Success (2xx)', 'Redirects (3xx)', 'Dependency Error (4xx)', 'Server Error (5xx)'];
  chartData: number[] = [0, 0, 0, 0];
  chartType = 'doughnut';
  colors: Color[] = [
    {
      backgroundColor: [
        '#00af00',
        '#ff9900',
        '#f7464a',
        '#8A2BE2'
      ]
    }
  ];
  options: ChartOptions = {
    legend: {
      display: true,
      position: 'right'
    },
    plugins: {
      title: {
        display: true,
        text: 'Tests',
        padding: {
          top: 10,
          bottom: 30
        }
      }
    }
  };

  constructor(public platform: LeftpanelComponent) {
  }

  ngOnInit() {

    this.setChartData();
  }

  setChartData() {
    let success = 0;
    let redirects = 0;
    let depError = 0;
    let serverError = 0;

    for (const log of this.sessionLogs.actions) {
      const val = log.responseStatusCode;

      if (200 <= val && val < 300) {
        success++;
      } else if (300 <= val && val < 400) {
        redirects++;
      } else if (400 <= val && val < 500) {
        depError++;
      } else if (val > 500) {
        serverError++;
      }
    }
    this.chartData = [success, redirects, depError, serverError];
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'sessionId': {
            this.setChartData();
          }
        }
      }
    }
  }

  tabChanged(event) {
    this.selectedTab = event.index;
  }


  getDataAndTime(timeStamp) {
    if (timeStamp) {
      const date_ob = new Date(timeStamp);
      let hours = date_ob.getHours();
      const minutes = ('0' + date_ob.getMinutes()).slice(-2);
      const seconds = ('0' + date_ob.getSeconds()).slice(-2);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;


      return (date_ob.toDateString()) + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
    } else {
      return '-';
    }
  }

  getCreatedDate(val) {
    // const data = val.split('#');
    // if (Number(data[2]) !== 0) {
    //     return new Date(Number(data[2])).toLocaleString();
    // } else {
    //     return new Date(Date.now() - Number(this.getTotalUptime(val)) * 1000 * 60 * 60).toLocaleString();
    // }

    if (val) {
      return this.platform.timeConverter(val);
    } else {
      return '-';
    }

  }

  public chartClicked(e) {

  }

  public chartHovered(e) {

  }
}
